import { render, staticRenderFns } from "./twoPointDialog.vue?vue&type=template&id=6732acc4&scoped=true&"
import script from "./twoPointDialog.vue?vue&type=script&lang=js&"
export * from "./twoPointDialog.vue?vue&type=script&lang=js&"
import style0 from "./twoPointDialog.vue?vue&type=style&index=0&id=6732acc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732acc4",
  null
  
)

export default component.exports